import request from 'api/request';

export default function sendResetEmailRoute(email) {
  return request({
    url: '/passwords/send-reset-email',
    method: 'POST',
    data: { email },
  });
}
